export enum ViewGridBlock {
  Root = 'ViewGrid',
}

export enum ViewGridElement {
  Header = 'header',
  Grid = 'grid',
  Title = 'title',
}
